'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');let

CreateUserModalController=(_dec=








































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class CreateUserModalController extends BaseController{static get $inject(){return['$modalInstance','socketService','uiCommandFactory','onUserCreated','uncaughtErrorHandler']}constructor($modalInstance,socketService,uiCommandFactory,onUserCreated,uncaughtErrorHandler){super(uncaughtErrorHandler);this._socketService=socketService;this._$modalInstance=$modalInstance;this._onUserCreated=onUserCreated;this._createUserCommand=uiCommandFactory.makeForModal($modalInstance,this._createCurrentUser.bind(this));this.emailErrorHandler=this.emailErrorHandler.bind(this);this._firstName=void 0;this._lastName=void 0;this._email=void 0;this._phone=void 0;this._role='admin'}onCancel(){this._$modalInstance.dismiss()}get createUserCommand(){return this._createUserCommand}get submissionResult(){return this._submissionResult}emailErrorHandler(submissionResult){if(_.exists(submissionResult)){if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===409){return`Email address "${this.email}" is already in use.`}}}
async _createCurrentUser(){
let createResult=await this._socketService.sendAndWaitForResponse('CreateUser',{
firstName:this._firstName,
lastName:this._lastName,
email:this._email,
phone:this._phone,
role:this._role});


this._submissionResult=createResult;

if(!SocketResponse.succeeded(createResult)){
return ModalSubmissionResult.KeepOpen;
}

await this._onUserCreated();

return ModalSubmissionResult.Close(UserInfo.fromJSON(createResult.body));
}

get firstName(){
return this._firstName;
}

set firstName(firstName){
this._firstName=firstName;
}

get lastName(){
return this._lastName;
}

set lastName(lastName){
this._lastName=lastName;
}

get email(){
return this._email;
}

set email(email){
this._email=email;
}

get phone(){
return this._phone;
}

set phone(phone){
this._phone=phone;
}

get role(){
return this._role;
}

set role(role){
this._role=role;
}},(_applyDecoratedDescriptor(_class.prototype,'_createCurrentUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_createCurrentUser'),_class.prototype)),_class));


module.exports=CreateUserModalController;
//# sourceMappingURL=createUserModalController.js.map
